import React, {Component} from "react";
import RadioWithImage from "../../components/RadioWithImage/RadioWithImage";
import merged from '../../images/merged.png';
import parent from '../../images/parent.png';
import GridDuck from 'gridduck';
import {Button, EditableList, StandardListCell, Dropdown, Input} from "gd-react";
import history from "../../meta/history";

class AddVirtualDevice extends Component {
    constructor(props) {
        super(props);
        ['setFooter', 'getActiveList', 'getAvailableList', 'devicesChanged', 'submitAsset'].forEach(func => this[func] = this[func].bind(this));
        this.state = {
            virtualType: 'parent', loadType: 0, page: 1, name: '', children: [], updateRef: 0
        };
    }

    dedupeById(list) {
        const seen = new Set();
        return list.filter(item => {
            if (seen.has(item.id)) return false;
            seen.add(item.id);
            return true;
        });
    }

    async getActiveList() {
        return Promise.resolve({
            list: this.dedupeById(this.state.children), total: this.dedupeById(this.state.children).length
        });
    }

    async getAvailableList(params) {
        const assets = await GridDuck.getAssets(params);
        return Promise.resolve(assets);
    }

    async submitAsset(e) {
        let self = this;
        this.setState({triedToSave: true});

        let res;
        const code = this.state.virtualType === 'merged' ? 'VIRTUAL-PARENT-MERGED' : 'VIRTUAL-PARENT';
        try {
            res = await GridDuck.createAsset({
                name: this.state.name,
                code: code,
                applianceType: 'Other',
                loadType: this.state.loadType,
                sku: code,
                siteId: this.props.siteId,
                groupIds: [this.props.siteId]
            });
        } catch (e) {
            if (e.message === 'Request failed with status code 409') {
                self.setState({error: 'Device already exists'});
                setTimeout(function () {
                    self.setState({error: null});
                }, 10000);
                return Promise.reject("AlreadyExists");
            } else {
                return Promise.reject(e);
            }
        }

        if (res && this.state.children) {
            let id = res.id;
            let promises = [];
            for (const child of this.state.children) {
                if (this.state.virtualType === 'merged') {
                    promises.push(child.setVirtualParentAsset(id))
                } else {
                    promises.push(child.setParentAsset(id))
                }
            }
            await Promise.all(promises).then(() => 'parent asset added to children')
        }
        this.props.closeModal();
        return Promise.resolve();
    }

    devicesChanged(a, b, itemsToAddRemove) {
        this.itemsToRemove = itemsToAddRemove.itemsToRemove;
        this.itemsToAdd = itemsToAddRemove.itemsToAdd;

        const currentChildren = this.state.children || [];

        // Remove any being taken out
        const remaining = currentChildren.filter(child => !itemsToAddRemove.itemsToRemove.some(rem => rem.id === child.id));

        // Add new ones
        const additions = itemsToAddRemove.itemsToAdd;

        // Merge and deduplicate by ID
        const merged = [...remaining, ...additions];
        const dedupedChildren = [];
        const seen = new Set();

        for (const item of merged) {
            if (!seen.has(item.id)) {
                dedupedChildren.push(item);
                seen.add(item.id);
            }
        }

        this.setState(prev => ({
            children: dedupedChildren, updateRef: prev.updateRef + 1
        }));
    }

    setFooter() {
        let self = this;
        let footer = [];
        if (this.state.page === 1) {
            footer.push((<div className={'button-container'}>
                <Button
                    key={'next-butt'}
                    onClick={() => {
                        self.setState({triedToNext: true}, () => {
                            if (!this.state.name.length) {
                                return false;
                            } else {
                                self.setState({page: 2}, () => {
                                    this.props.setWide(true);
                                    this.props.updateFooter(self.setFooter());
                                })
                                return true;
                            }
                        })
                    }}
                    label={"Next"}
                    color={"gd-brand"}
                />
            </div>));
            footer.push((<div className={'button-container'}>
                <Button
                    onClick={() => {
                        self.setState({
                            page: 1,
                            mac: '',
                            dataType: null,
                            manualHub: null,
                            deviceType: null,
                            site: null,
                            triedToSave: false, // children: []
                        }, () => {
                            this.props.setWide(false);
                            this.props.backToTypeSelection();
                        })
                    }}
                    label={"Back"}
                    outline
                    color={"gd-grey"}
                />
            </div>))

        } else if (this.state.page === 2) {
            footer.push((<div className={'button-container'}>
                <Button
                    key={'submit-butt'}
                    // additionalclasses={'sm left'}
                    onClick={this.submitAsset}
                    progressRes={true}
                    label={"Create Device"}
                    color={"gd-green"}
                />
            </div>))
            footer.push((<div className={'button-container'}>
                <Button
                    onClick={() => {
                        this.setState({
                            page: 1, // children: []
                        }, () => {
                            this.props.setWide(false);
                            this.props.updateFooter(self.setFooter());
                        })
                    }}
                    label={"Back"}
                    outline
                    color={"gd-grey"}
                />
            </div>))
        }
        return footer;
    }

    componentDidMount() {
        this.props.updateFooter(this.setFooter());
    }

    render() {
        const devicesMessage = <div>
            <div className={'page-padding'}>
                <h4>Devices</h4>
                <p>Select the devices that will make up this virtual device.
                    <br/>
                    <span
                        className={'info'}>As you selected {`"${this.state.virtualType}" it means these devices will ${this.state.virtualType === 'parent' ? 'appear as children' : 'be hidden from most views'} and the sum of their usage will be ${this.state.name}'s total.`}</span>
                </p>
            </div>
        </div>


        let pages = [<div className={`form-container ${this.state.page === 2 ? 'with-list' : ''}`}>
            {this.state.page === 1 && <div>
                <div style={{marginBottom: '15px'}}>
                    <Input required error={this.state.triedToNext && !this.state.name.length} top='true'
                           onChange={(val) => this.setState({name: val.target.value})}
                           name={'name'} value={this.state.name} label={'Name'}/>
                </div>
                <RadioWithImage
                    name="device-type"
                    value={this.state.virtualType}
                    label={'Device Type'}
                    onChange={(val) => this.setState({virtualType: val})}
                    options={[{
                        value: "parent",
                        label: "Parent Device",
                        image: parent,
                        description: "A collection of linked devices, allowing the original devices to be viewed and arranged."
                    }, {
                        value: "merged",
                        label: "Merged Device",
                        image: merged,
                        description: "A merged collection of devices, removing the original devices from view."
                    }]}
                />
                <RadioWithImage
                    name="load-type"
                    value={this.state.loadType}
                    label={'Load Type'}
                    columns={2}
                    onChange={(val) => this.setState({loadType: val})}
                    options={[{
                        value: 0,
                        label: "Import Only",
                        icons: [{icon: 'FaBolt', color: '#ffca00'}],
                        description: "Tracks energy use only."
                    }, {
                        value: 1,
                        label: "Generation Only",
                        icons: [{icon: 'FaSolarPanel', color: '#3ad56e'}],
                        description: "Tracks energy generation only."
                    }, {
                        value: 2,
                        label: "Import, Generation & Export",
                        icons: [{icon: 'FaBolt', color: '#ffca00'}, {
                            icon: 'FaSolarPanel', color: '#3ad56e'
                        }, {icon: 'FaArrowAltCircleUp', color: '#3ad56e'}],
                        description: "Tracks both energy use and generation."
                    }]}
                />
            </div>}
            {this.state.page === 2 &&
                <div className={'row'} style={{overflow: 'hidden'}}>
                    <EditableList
                        isEditing={true}
                        key={1}
                        onChange={this.devicesChanged}
                        noCancel={true}
                        asyncActive
                        updateRef={this.state.updateRef}
                        noSave
                        availableFilters={[{field: 'siteId', value: this.props.siteId}]}
                        activeColumns={[{
                            component: StandardListCell, maxWidth: '200px', title: 'Name', custom: function (item) {
                                return <span style={{fontWeight: 700}}>{item.name}</span>
                            }
                        }
                        ]}
                        getActiveList={this.getActiveList}
                        getAvailableList={this.getAvailableList}
                    />
                </div>}
        </div>]
        if (this.state.page === 2) {
            pages.unshift(devicesMessage);
        }
        return pages;
    }
}

export default AddVirtualDevice;